<ng-multiselect-dropdown class="custom-dropdown"
                         [placeholder]='placeholder | localize'
                         [settings]="dropdownSettings"
                         [data]="data"
                         [disabled]="disabled"
                         [(ngModel)]="inputModel"
                         (ngModelChange)="inputModelChangeEvent(inputModel)"
                         [ngModelOptions]="{standalone: true}">
</ng-multiselect-dropdown>
<span *ngIf="showMessageError"
      class="error invalid-feedback d-block ng-star-inserted">
    {{ "ThisFieldIsRequired" | localize }}
</span>
